import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMariaIconDarkGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={22} fill="none" {...props}>
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.299}
      d="M8.849 8.887c.166.535.144.85.133 1.1-.007.147-.103.69-.31 1.324-.167.456.311.447.536.369M9.756 11.635c.085 0 .194-.026.28-.026"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.373}
      d="M7.205 12.364q.201.097.42.177c1.574.576 3.06.168 3.569.022a7 7 0 0 0 .347-.11"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.373}
      d="M7.432 12.557c.119.237.374.653.862.937.717.418 1.698.413 2.39-.1.373-.276.563-.627.655-.837"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M10.218 4.854c-.537-.062-1.726-.132-2.157-.11-2.414.117-4.215 3.648-4.505 3.291-.34-.418.224-2.699.553-3.119.14-.178-1.476 1.61-1.46 1.365.015-.241.066-1.33.785-2.294.597-.8 2.266-1.064 1.974-1.124-.547-.112-1.403-.483-1.222-.535.202-.058 1.06-.037 2.345-.542.867-.34.79-.314 1.493-.564.528-.188 1.75-.443 2.93.133.327.159 1.07.52 1.384 1.349.264.7.214 1.715-.332 2.101-.397.28-.331.215-1.788.048z"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M10.172 4.832c.015-.152.055-.546-.11-.87a1.48 1.48 0 0 0-1.013-.78c-.996-.243-1.957.393-2.09.497M11.205 4.928c.06-.18.206-.573.177-.949a1.8 1.8 0 0 0-.54-1.152c-.527-.502-1.243-.42-1.352-.406M12.563 3.318c.208.01.726-.01 1.214.326.163.112.724.529.821 1.188.065.44.03.706-.188 1.86-.242 1.272-.342 2.079-.376 1.913-.024-.115.068-1.05-.42-2.058-.381-.789-1.053-1.32-1.286-1.467a3 3 0 0 0-.4-.22"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M12.43 5.027a3.03 3.03 0 0 1 1.887-.664M5.308 6.303c-.112.3-.29.94-.365 1.472a6.9 6.9 0 0 0-.062 1.638c.12 1.46.284 2.208.676 3.298.38 1.053 1.044 1.597 1.46 1.977.634.575 1.144.99 2.053 1.21.413.1.775-.003.917-.036.18-.043.843-.412 1.705-1.106a5.1 5.1 0 0 0 1.541-2.013c.249-.575.413-1.105.607-2.293.117-.717.173-1.504.213-1.92"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M14.042 8.644c.03-.079.24-.312.428-.364.293-.083.52.042.638.348.353.911.143 2.015-.44 2.737-.328.408-.804.51-1.053.573"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.324}
      d="M14.689 9.3c-.099.252-.598.182-.635.422-.03.202.405.5.328.699"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M4.843 8.598c-.029-.08-.3-.266-.487-.318-.293-.083-.52.042-.64.348-.352.911-.141 2.015.44 2.737.33.408.806.51 1.054.573"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.324}
      d="M4.133 9.3c.098.252.598.182.634.422.031.202-.404.5-.327.699"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.249}
      d="M4.024 7.702c-.087.133.167.425.228.524"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M12.017 14.495c-.024.405-.03.985.033 1.519.045.381.114.726.19 1.028M6.774 14.56c.024.405.031.985-.032 1.52a8 8 0 0 1-.191 1.028"
    />
    <path
      stroke="#666"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.149}
      d="M12.735 9.097c-.1-.072-.524-.3-.942-.285-.579.02-.929.418-.986.486"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M12.074 14.736c.168.04.471.084.74.27.164.113.548.378.697.828.176.534-.15.814.055 1.209.148.285.448.385.732.492.504.19 3.043 2.116 3.159 3.427M6.794 14.736c-.168.04-.471.084-.74.27-.164.113-.548.378-.696.828-.177.534.15.814-.056 1.209-.148.285-.447.385-.732.492-.504.19-3.57 2.183-3.57 3.427M12.046 15.367c.43.319.585.564.578.73-.008.18-.119.254-.141.578-.013.182.014.266-.05.367-.09.14-.257.151-.357.191-.403.164-.405 1.095-.423 1.66A20 20 0 0 1 11.471 21M13.76 17.408c-.036.165-.1.406-.224.68-.13.284-.3.664-.69.97-.141.113-.42.3-.846.39"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M11.744 18.984c.119.091.254.238.252.342-.01.648-.346 1.635-.525 1.674M13.152 18.884c.335.407.937 1.596 1.117 2.077M6.705 15.288c-.43.319-.662.605-.654.771.008.18.119.254.141.578.013.182-.015.267.05.367.09.141.256.151.356.192.404.163.406 1.095.424 1.659.015.496.057 1.21.182 2.107"
    />
    <path
      stroke="#666"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.149}
      d="M6.014 9.067c.1-.072.524-.3.942-.286.579.02.929.419.986.487"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.722}
      d="M4.922 17.418c.035.165.089.357.213.631.129.285.3.664.688.97.143.113.421.3.847.39M6.932 18.945c-.119.09-.25.238-.252.341-.014.648.204 1.575.526 1.713M5.519 18.845c-.335.407-1.013 1.685-1.234 2.154M11.61 18.72c-.249.146-.696.38-1.188.477-.807.157-1.148.178-1.799.054-.651-.125-1.204-.445-1.58-.66"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.348}
      d="M10.607 9.424c.06-.157.19-.415.457-.606a1.32 1.32 0 0 1 1.56.011c.188.139.296.373.314.528M13.275 8.743c-.05.243-.24.492-.328.622M12.856 8.972c.093-.014.259-.15.404-.222M8.16 9.4a1.32 1.32 0 0 0-.457-.606 1.32 1.32 0 0 0-1.56.011.84.84 0 0 0-.315.528M5.488 8.719c.05.242.24.492.328.622M5.912 8.947c-.093-.014-.26-.155-.404-.228"
    />
    <path
      fill="#242424"
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.348}
      d="M7.145 9.95a.585.585 0 1 0 0-1.17.585.585 0 0 0 0 1.17M11.708 9.918a.585.585 0 1 0 0-1.17.585.585 0 0 0 0 1.17"
    />
    <path
      stroke="#47008B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.249}
      d="M11.63 9.917a.378.378 0 1 0 0-.755.378.378 0 0 0 0 .755M7.204 9.917a.378.378 0 1 0 0-.755.378.378 0 0 0 0 .755"
    />
    <path
      fill="#fff"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.274}
      d="M6.763 9.231c.032-.03.023-.09-.018-.131s-.1-.05-.132-.018c-.031.03-.023.09.019.131s.1.05.131.018M12.147 9.214c.042-.042.05-.1.019-.132-.032-.031-.09-.023-.132.018-.042.042-.05.1-.018.132.031.031.09.023.131-.018"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.274}
      d="M10.455 8.016c.104-.13.44-.581 1.36-.768a1.27 1.27 0 0 1 1.063.223c.172.124.327.326.383.436"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.274}
      d="M10.455 8.017c.373-.134.556-.209.962-.292.547-.111.77-.105.934-.109.29-.005.781.184.895.28"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.398}
      d="M10.92 7.7c.618-.212 1.089-.3 1.7-.242"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.274}
      d="M8.362 8.1c-.104-.13-.44-.581-1.36-.768a1.27 1.27 0 0 0-1.062.223 1.4 1.4 0 0 0-.383.436"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.274}
      d="M8.357 8.1c-.372-.134-.555-.21-.962-.292-.547-.111-.77-.106-.933-.109-.29-.004-.831.197-.898.28"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.398}
      d="M7.892 7.783c-.618-.211-1.089-.299-1.7-.24"
    />
    <path
      stroke="#242424"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.174}
      d="M8.799 14.206q.056.058.3.095c.243.04.546.034.777-.017.127-.027.214-.059.244-.094"
    />
    <path
      fill="#fff"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.174}
      d="M7.692 9.482c.028 0 .05-.021.049-.046 0-.025-.024-.044-.052-.044-.028.001-.05.022-.049.047 0 .025.024.044.052.043M11.143 9.442c.028-.001.05-.022.05-.047-.002-.025-.025-.044-.053-.043-.028 0-.05.022-.049.046.001.025.024.045.052.044"
    />
  </svg>
);
export default SvgMariaIconDarkGrey;
